













 import Vue from 'vue'

 import checkbox from '@/components/controls/checkbox/checkbox.vue';

 import { PriceSettings } from '@/types/price-settings'


import style from './style.module.scss'

export default Vue.extend({
    name: 'product-price-setting-dist-cell',
    components: {
        checkbox
    },
    props: {
        data: {} as () => PriceSettings,
        typeCode: String
    },
    data() {
        return {
            style: style
        }
    },
    methods: {
        toggle(row: PriceSettings) {
            this.$store.dispatch('toggle', { row, typeCode: this.typeCode });
        },
        check(row: PriceSettings, inputValue: boolean) {
            this.$store.dispatch('check', { row, inputValue, typeCode: this.typeCode });
        }
    },
    computed: {
        toggleClassList(): string[] {
            const classList = [this.style.distCellToggle];

            if(this.data.Expanded) classList.push(this.style.distCellToggleExpanded);

            return classList;
        },
        showAsterics(): boolean {
            return this.data.AnyChildFilled;
        }
    }
})
